import { MenuItem, styled, TextFieldProps } from '@mui/material'
import InputBase from 'design-system/input/base'
import React, { useState } from 'react'

const StyledSelectBox = styled(InputBase)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.background.paper
  }
}))

/**
 * SelectBoxProps type defines the properties for the SelectBox component.
 */
export type SelectBoxProps = {
  /** The items to display in the select box */
  menuItems: Array<{
    value: string
    label: string
  }>
  /** control prop for managing the select box state */
  control?: [any, React.Dispatch<React.SetStateAction<any>>]
} & TextFieldProps

/**
 * SelectBox component
 * This component renders a select box with the given menu items.
 * @param {SelectBoxProps} props - The properties for the SelectBox component.
 * @returns {JSX.Element} The rendered SelectBox component.
 */
const SelectBox: React.FC<SelectBoxProps> = ({
  menuItems,
  defaultValue,
  control,
  ...props
}) => {
  const [innerValue, setInnerValue] = useState<string>(
    typeof defaultValue === 'string' ? defaultValue : ''
  )
  const [value, setValue] = control ?? [innerValue, setInnerValue]

  return (
    <StyledSelectBox
      {...props}
      select
      value={value?.toString() ?? ''}
      onChange={e => {
        setValue(e.target.value)
      }}
    >
      {menuItems.map(item => (
        <MenuItem key={`select-item-${item.value}`} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </StyledSelectBox>
  )
}

export default SelectBox
